module.exports = __webpack_public_path__ + "static/media/Grupodetrabajo.7bd6deba.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/SupervisorChat/Grupodetrabajo.svg
// module id = 1832
// module chunks = 0